<template>
  <div class="breadcrumb-wrapper">
    <div class="progress-bar">
      <div class="line"></div>
      <div class="dots">
        <div class="dot" :class="{'active': isCurrentStep(1), 'completed': isStepCompleted(1)}"></div>
        <div class="dot" :class="{'active': isCurrentStep(2)}"></div>
        <div class="dot"></div>
      </div>
    </div>
    <ul class="breadcrumb">
      <li class="breadcrumb-item" :class="{'active': isCurrentStep(1), 'completed': isStepCompleted(1)}">Wybór operatora</li>
      <li class="breadcrumb-item" :class="{'active': isCurrentStep(2)}">Szczegóły doładowania</li>
      <li class="breadcrumb-item">Podsumowanie i&nbsp;płatność</li>
    </ul>
  </div>
</template>

<script>
import ProgressMixin from '@/common/mixins/Topup/Progress.mixin'

export default {
  name: 'TopupPhoneBreadcrumbs',
  mixins: [ProgressMixin]
}
</script>
